import { PeopleEmployeeDto } from "./people-employee.dto";

export class PeopleEmployeeBankDetailsDto {
    id?: number;
    employeeId?: number;
    employeeIBAN?: string;
    employeeSwiftBic?: string;
    employeeAccountName?: string;
    createdDate?: Date;
    modifiedDate?: Date;
    lastModifiedUserId?: number;
    version?: number;

    employee?: PeopleEmployeeDto;
}